import { render, staticRenderFns } from "./bindAccount.vue?vue&type=template&id=3dc25fa6"
import script from "./bindAccount.vue?vue&type=script&lang=js"
export * from "./bindAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports